import { Project } from '../objects/Project.interface';
import { createNewProject, ProjectsService } from "../services/Projects.service";
import React from "react";

import Button from "@mui/material/Button";
import Anotator from './Anotator';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { TextField } from '@mui/material';
import ProjectDetails from './ProjectDetails';
import ProjectList from './ProjectList';
import { Entity } from '../objects/Entity.interface';
import { createNewEntity } from '../services/Entities.service';
import ProjectImport from './ProjectImport';

export type DefaultProps = {};
class Main extends React.Component<DefaultProps, {page:string, openDialog:boolean}>{

    
    //services
    private _projectService =  new ProjectsService();
    
    //object lists
    _projectList:Project[] = [];
    _selectedProject: Project = createNewProject();

    entitySelected: Entity = createNewEntity();


    constructor (props: DefaultProps){
        super(props);
        this.state = {
         page: 'projects',
         openDialog: false   
        }
        this.initProjects();
        this.initPersistStorage();
        
    }

    initPersistStorage = async () =>{
        const estimate = await navigator.storage.estimate();
        console.log(`Using ${estimate.usage} of ${estimate.quota} bytes`);

        if (navigator.storage && navigator.storage.persist) {
        const isPersistent = await navigator.storage.persist();
        if (isPersistent) {
            console.log("¡Almacenamiento persistente concedido por el navegador!");
        } else {
            console.log("Almacenamiento persistente denegado.");
        }
    }
    }

    //init
    //Get available proyects in indexedDB 
    initProjects = () => {

        
        //
        var result = this._projectService.getList();
        result.then(res => {
            this._projectList = res? (res as Project[]): ([] as Project[]);
            this.forceUpdate();
        });
    }


    /**
     * Show import screen settings 'import' value to state.page
     */
    handleImportProject = () => {
        this.setState({ page: 'import'});
    }

    /**
     * 
     * @param project 
     */
    openCorpus = (project:Project) => {
        var projectId = (project.id)?project.id:0;
        sessionStorage.setItem('currentProjectId', projectId.toString());
        this._selectedProject = project;
        this.setState({ page: 'annotations'});
    }

    openProject = (project:Project) => {
        this._selectedProject = project;
        this.setState({ page: 'project'});
    }

    /** 
     * Once time comfirmed delete the project this method execute the serve to delete the project and related records from database
     */
    deleteProject = (project:Project) => {
        var result = this._projectService.delete(project.id!);
        result.then(res => {
            this.initProjects();
        });
        
    }


    /***
     * Get available projects and show projects screen 
     */
    openProjects = ()=>{
        this.initProjects();
        this.setState({page: 'projects', openDialog: false});
    }

    /**
       * Open dialog to create a new project
       */
    handleOpenNewProjectDialog = () => {
        this.setState({openDialog:true});
      };
    
      /**
       * Close dialog to create a new project
       */
    handleCloseDialog = () => {
        this.setState({openDialog:false});
      };

    render(): React.ReactNode{
        return (
            
            <div className="area-tool-main-container">
                {
                    this.state.page === "projects" && <div className="area-tool-container">
                        <Dialog
                            open={this.state.openDialog}
                            onClose={this.handleCloseDialog}
                            PaperProps={{
                            component: 'form',
                            onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                                event.preventDefault();
                                const formData = new FormData(event.currentTarget);
                                const formJson = Object.fromEntries((formData as any).entries());
                                const projectName = formJson.name;
                                const projectDescription = formJson.description;
                                var resultAdd = this._projectService.add({name: projectName, description: projectDescription});

                                resultAdd.then(res => {
                                    this.initProjects();
                                    this.handleCloseDialog();
                                });
                                
                            },
                            }}
                        >
                            <DialogTitle>New Project</DialogTitle>
                            <DialogContent>
                            <TextField
                                autoFocus
                                required
                                margin="dense"
                                id="name"
                                name="name"
                                label="Name"
                                type="text"
                                fullWidth
                                variant="standard"
                            />
                            <TextField
                                
                                margin="dense"
                                id="description"
                                name="description"
                                label="Description"
                                type="text"
                                fullWidth
                                variant="standard"
                            />
                            
                            </DialogContent>
                            <DialogActions>
                            <Button onClick={this.handleCloseDialog}>Cancel</Button>
                            <Button variant='contained' type="submit">Create</Button>
                            </DialogActions>
                        </Dialog>
                        <div className="area-entities-header">
                        <div className="area-entities-header-content">
                            <i className="area-entities-title">Projects</i>
                            <div  className='area-projects-button-add'>
                                <Button  variant="contained" style={{position: 'absolute', right: '15px',top: '30px'}}  size='small' onClick={this.handleOpenNewProjectDialog}>
                                    New Project
                                </Button>
                                <Button  variant="contained" style={{position: 'absolute', right: '145px',top: '30px'}}  size='small' onClick={this.handleImportProject}>
                                    Import Project
                                </Button>

                            </div>
                            
                        </div>
                            <div id="area-corpus-separator" className="separator"></div>
                        </div>

                        <ProjectList Projects={this._projectList} OpenCorpus={this.openCorpus} DeleteProject={this.deleteProject} OpenDetails={this.openProject}></ProjectList>
                    </div>
                }
              
                {
                    this.state.page === "annotations" && <Anotator Project={this._selectedProject} backProjects= {this.openProjects} />
                }
                {
                    this.state.page === "project" && <ProjectDetails Project={this._selectedProject} backProjectsScreen= {this.openProjects} openDashboard={this.openCorpus}  />
                }
                {
                    this.state.page === "import" && <ProjectImport backProjectsScreen= {this.openProjects} openDashBoard={this.openCorpus}/>
                }
            </div>
        );
    }
}

export default Main;